module.exports = __webpack_public_path__ + "static/media/YM51_3.dc0f6027.jpg";